<template>
    <div class="main-footer">

        <footer>
            <div class="footer-inner">
                <div class="branding">
                    <img src="/img/intervention-central-logo.png" alt="intervention central logo"/>
                    <span>Intervention Central</span>
                </div>
                <div class="copyright">&copy; copyright Intervention Central {{ copyrightDate | moment("YYYY") }}</div>
            </div>
        </footer>


    </div>
</template>

<script>

    import Vue from 'vue'

    export default Vue.extend({
        name: "MainFooter",
        computed: {
            copyrightDate() {
                return new Date()
            }
        }
    })
</script>

<style lang="scss">

    .main-footer {
        @media print {
            display: none;
        }

        position: relative;
        z-index: 1;

        footer {
            //position: fixed;
            //bottom: 0;
            //left: 0;
            //right: 0;
        }

        footer {
            //background-color: #E8E2DC;
            padding: 15px 15px 30px;
            //border-top: solid 1px #fff;
            //-webkit-box-shadow: 0 0 20px rgba(0, 0, 0, .15);
            //-moz-box-shadow: 0 0 20px rgba(0, 0, 0, .15);
            //box-shadow: 0 0 20px rgba(0, 0, 0, .15);
        }

        footer .branding {
            overflow: hidden;
            line-height: 24px;
            text-align: center;
            margin: 1em 0 .5em;
        }

        footer .branding img {
            display: inline-block;
            width: 14px;
            margin-right: 10px;
        }

        footer .branding span {
            font-weight: bold;
        }

        .copyright {
            text-align: center;
            margin-top: 1em;
            font-size: 12px;
            color: #999;
        }

        @media (min-width: 768px) {
            footer .branding {
                //text-align: left;
            }

            footer .branding img {
                //float: left;
            }

            .copyright {
                margin-top: 0;
                //position: absolute;
                //right: 15px;
                //top: 50%;
                //-webkit-transform: translateY(-50%);
                //transform: translateY(-50%);
            }
        }
    }
</style>
